import { render, staticRenderFns } from "./CartasRespostaEditar.vue?vue&type=template&id=5b12f6e2"
import script from "./CartasRespostaEditar.vue?vue&type=script&lang=js"
export * from "./CartasRespostaEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports